import { render, staticRenderFns } from "./DevicesOtherOutlined.vue?vue&type=template&id=2454b542&"
import script from "./DevicesOtherOutlined.vue?vue&type=script&lang=js&"
export * from "./DevicesOtherOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports